import { Flex, IconButton, PseudoBox, Stack, Text } from '@chakra-ui/core';
import { useObserver } from 'mobx-react';
import React from 'react';

import { useStores } from '../hooks/useStores';

function useStoreData() {
    const { store } = useStores();
    return useObserver(() => ({
        backupTracks: Array.from(store.playback.backupTracks.values()),
        addToQueue: store.playback.addToQueue,
        removeFromBackup: store.playback.removeFromBackup,
    }));
}

const BackupTracks = () => {
    const { backupTracks, addToQueue, removeFromBackup } = useStoreData();
    return (
        <Stack spacing={0}>
            {backupTracks.length ? (
                backupTracks.map(track => {
                    return (
                        <PseudoBox
                            _hover={{ bg: 'rgba(0,0,0,.1)' }}
                            as="div"
                            d="flex"
                            w="100%"
                            p=".5rem 1rem"
                            justifyContent="space-between"
                            alignItems="center"
                            opacity={0.6}
                            transition="all .3s ease"
                            key={`backupTrack-${track.id}`}
                        >
                            <IconButton
                                mr=".5rem"
                                variant="ghost"
                                aria-label="Add track to queue"
                                icon="add"
                                onClick={() => {
                                    addToQueue(track);
                                    removeFromBackup(track);
                                }}
                            ></IconButton>
                            <Flex direction="column" flex={1}>
                                <Text maxW={['150px', '250px', '200px', '300px']} isTruncated flex={1}>
                                    {track.name}
                                </Text>
                                <Text
                                    fontSize="14px"
                                    opacity={0.7}
                                    maxW={['130px', '230px', '180px', '250px']}
                                    isTruncated
                                    flex={1}
                                >
                                    {track.artists}
                                </Text>
                            </Flex>
                        </PseudoBox>
                    );
                })
            ) : (
                <Text></Text>
            )}
        </Stack>
    );
};

export default BackupTracks;
